export type GeneratedPageDataSource = "mock" | "remote";

export interface GeneratedPageDataConfig {
  dataKeys?: string[];
  mockData?: Record<string, any>;
  mockLoader?: () => Promise<Record<string, any>>;
  defaultSource?: GeneratedPageDataSource;
  /**
   * loading 期间是否透传渲染组件（而非显示全屏「数据加载中」占位）。
   * 开启后，组件在数据未就绪时自行渲染骨架屏，避免首屏白屏闪烁。
   * 组件通过 data?.list 等字段是否就绪自行判断 loading 态。
   */
  loadingPassthrough?: boolean;
}

export function resolveGeneratedPageDataSource(
  config?: GeneratedPageDataConfig,
  mockSearchParam?: string | null,
): GeneratedPageDataSource {
  if (mockSearchParam === "1") {
    return "mock";
  }

  if (mockSearchParam === "0") {
    return "remote";
  }

  if (config?.defaultSource) {
    return config.defaultSource;
  }

  if (config?.dataKeys?.length) {
    return "remote";
  }

  return "mock";
}

export function getGeneratedPageDataConfigError(
  source: GeneratedPageDataSource,
  config?: GeneratedPageDataConfig,
): GeneratedPageDataSource | null {
  if (source === "remote" && !config?.dataKeys?.length) {
    return "remote";
  }

  if (source === "mock" && !config?.mockData && !config?.mockLoader) {
    return "mock";
  }

  return null;
}
